module.exports = __webpack_public_path__ + "static/media/ProfessionalBehavior.ae05185d.svg";